<template>
	<div class="wrap">
		<myHead></myHead>
		<div class="wrap_body">
			<div class="notice_head">
				<div class="center">
					<div class="page_links">
						当前位置：
						<el-breadcrumb separator-class="el-icon-arrow-right">
							<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
							<el-breadcrumb-item>平台规则</el-breadcrumb-item>
						</el-breadcrumb>
					</div>
					<div class="tabs_wrap">
						<p :class="type==1?'tab active':'tab'" @click="type=1">轻货供应链公告</p>
						<p :class="type==2?'tab active':'tab'" @click="type=2">抵扣金解读</p>
						<p :class="type==3?'tab active':'tab'" @click="type=3">隐私声明</p>
						<p :class="type==4?'tab active':'tab'" @click="type=4">用户协议</p>
					</div>
				</div>
			</div>
			<div class="notice_content">
				<div class="center">
					<div class="notice_menu">
						<p class="tit">全部公告</p>
						<ul class="menu_list auto_scrollbar">
							<li><p class="active">阶梯价档数变更意见征集</p></li>
							<li><p>通知！2022年轻货供应链端午代发&相关工作安排&相关工作安排&相关工作安排</p></li>
							<li><p>一起做网店“轻货供应链”邀你一起来参加</p></li>
							<li><p>轻货供应链买家保障保证金补缴通知</p></li>
							<li><p>阶梯价档数变更意见征集</p></li>
							<li><p>通知！2022年轻货供应链端午代发&相关工作安排&相关工作安排&相关工作安排</p></li>
							<li><p>一起做网店“轻货供应链”邀你一起来参加</p></li>
							<li><p>轻货供应链买家保障保证金补缴通知</p></li>
							<li><p>阶梯价档数变更意见征集</p></li>
							<li><p>通知！2022年轻货供应链端午代发&相关工作安排&相关工作安排&相关工作安排</p></li>
							<li><p>一起做网店“轻货供应链”邀你一起来参加</p></li>
							<li><p>轻货供应链买家保障保证金补缴通知</p></li>
						</ul>
					</div>
					<div class="notice_main">富文本</div>
				</div>
			</div>
		</div>
		<myFoot></myFoot>
	</div>
</template>

<script>
import Vue from 'vue';
import {Breadcrumb,BreadcrumbItem} from 'element-ui'
import myHead from '../../components/myHead/myhead';
import myFoot from '../../components/myFoot/myfoot';
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
export default {
	name: "noticeCenter",
	data() {
		return {
			type:'1',
			
		}
	},
	components:{
		myHead,myFoot
	},
	created(){
		console.log(this.$route.query)
		this.type = this.$route.query.type
	},
	methods: {
		
	}
}
</script>

<style scoped>
.wrap{background: #fff;}
.center{display: flex;align-items: flex-start;}
.notice_head .center{flex-direction: column;}
.notice_head{width: 100%;height: 112px;border-bottom: 1px solid #eee;position: sticky;top: 98px;z-index: 99;background: #fff;}
.tabs_wrap{flex: 1;height: 0;display: flex;margin-top: 20px;}
.tabs_wrap .tab{padding: 0 25px;height: 100%;display: flex;justify-content: center;align-items: center;position: relative;color: #666666;cursor: pointer;}
.tabs_wrap .tab.active{color: var(--red);font-weight: bold;}
.tabs_wrap .tab.active::after{content: '';width: 100%;height: 3px;background: var(--red);position: absolute;left: 0;bottom: 0;z-index: 2;}

.notice_content{margin-bottom: 40px;}
.notice_menu{width: 286px;max-height: 480px;box-sizing: border-box;padding: 26px 20px;background: #f5f5f5;display: flex;flex-direction: column;position: sticky;top: 210px;}
.notice_menu .tit{line-height: 1;font-size: 14px;font-weight: bold}
.notice_menu .menu_list{margin-top: 5px;flex: 1;height: 0;overflow-y: auto;overflow-x: hidden;}
.notice_menu .menu_list>li{padding: 14px 0;border-bottom: 1px solid #ddd;font-size: 14px;line-height: 18px;}
.notice_menu .menu_list>li:last-child{border-bottom: none;}
.notice_menu .menu_list>li>p{cursor: pointer;}
.notice_menu .menu_list>li>p.active{color: var(--red);display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;}
.notice_menu .menu_list>li>p:hover{color: var(--red);text-decoration: underline;}
.notice_main{flex: 1;width: 0;margin-left: 40px;margin-top: 40px;height: 1000px;}
</style>
<style>
.page_links{line-height: 1;font-size: 14px;color: #999999;display: flex;margin-top: 25px;}
.page_links .el-breadcrumb__inner{font-weight: bold !important;color: #333 !important;}
.page_links .el-breadcrumb__inner.is-link{font-weight: initial !important;color: #999 !important;}
.page_links .el-breadcrumb__inner.is-link:hover{color: #f0423f !important;text-decoration: underline;}
</style>